import React from "react";
import FlightTicketResult from "./FlightTicketResult";

const FlightTicketCard = (props) => {
    return (
        <div className="ticket-root">
            {props.data?.onwardJourney && (
                <>
                    {props.state?.isPerPassenger ? (
                        props.data?.passengers &&
                        props.data.passengers.map((passenger, passengerindex) => {
                            return (
                                <div className="ticket-card shadow-min">
                                    <FlightTicketResult
                                        data={props?.data}
                                        state={props?.state}
                                        passenger={passenger}
                                        passengerindex={passengerindex}
                                        key={passengerindex}
                                        markup={props?.markup}
                                        journey={props.data?.onwardJourney}
                                        journeyType={"onward"}
                                        isStatusLoading={props?.isStatusLoading}
                                        appconst={props?.appconst}
                                    />
                                </div>
                            );
                        })
                    ) : (
                        <div className="ticket-card shadow-min">
                            <FlightTicketResult
                                data={props?.data}
                                state={props?.state}
                                markup={props?.markup}
                                journey={props.data?.onwardJourney}
                                journeyType={"onward"}
                                isStatusLoading={props?.isStatusLoading}
                                appconst={props?.appconst}
                            />
                        </div>
                    )}
                </>
            )}
            <div className="page-break"></div>

            {props.data.returnJourney?.length > 0 && (
                <>
                    {props.state?.isPerPassenger ? (
                        props.data?.passengers &&
                        props.data.passengers.map((passenger, passengerindex) => {
                            return (
                                <div className="ticket-card shadow-min">
                                    <FlightTicketResult
                                        data={props?.data}
                                        state={props?.state}
                                        passenger={passenger}
                                        passengerindex={passengerindex}
                                        key={passengerindex}
                                        markup={props?.markup}
                                        journey={props.data?.returnJourney}
                                        journeyType={"return"}
                                        isStatusLoading={props?.isStatusLoading}
                                        appconst={props?.appconst}
                                    />
                                </div>
                            );
                        })
                    ) : (
                        <div className="ticket-card shadow-min">
                            <FlightTicketResult
                                data={props?.data}
                                state={props?.state}
                                markup={props?.markup}
                                journey={props.data?.returnJourney}
                                journeyType={"return"}
                                isStatusLoading={props?.isStatusLoading}
                                appconst={props?.appconst}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default FlightTicketCard;
